module.exports = __webpack_public_path__ + "static/media/insurance-commercial-640.ddc83d78.jpg";